import React from 'react';
import useStyle from './productSingleView.style';
import { SingleProductPresentation } from './SingleProductPresentation';
import { ProductInfoBlock } from './ProductInfoBlock';
import { ProductTypes } from '../../../types/product/product';
import { ContainerTwoThirds } from 'components/layouts/ContainerTwoThirds';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import { BackButton } from 'components/molecules/Buttons/BackButton';
import emojis from 'theme/emoji';
import { Panier } from '../Panier';
import { ShoppingMobiles } from './ShoppingMobiles';

interface ProductSingleViewProps {
  produit: ProductTypes;
  isPublicShop: boolean;
}

export const ProductSingleView = ({
  produit,
  isPublicShop
}: ProductSingleViewProps) => {
  const classes = useStyle();

  return (
    <ContainerTwoThirds
      col1={
        <div>
          <BackButton />
          <div className={classes.line1}>
            <SingleProductPresentation produit={produit} />
          </div>
          <div className={classes.line1}>
            <ProductInfoBlock produit={produit} />
          </div>
          {!isPublicShop && (
            <div className={classes.line1}>
              <ShoppingMobiles shoppingMobiles={produit.shoppingMobile} />
            </div>
          )}
        </div>
      }
      col2={
        <>
          <div className={classes.panier}>
            <HeaderText text="Votre panier" emoji={emojis['ShoppingCart']} />
          </div>
          <Panier />
        </>
      }
      variant="productSingle"
    />
  );
};
